<template>
  <div class="nettdoc-pregnancy-detail">
    <SectionHeader
      text="I'm pregnant"
      img="pregnant"
      alt="pregnant woman"
      :collapsable="true"
      v-on:collapse="collapsed = !collapsed"
      :complete="store.pregnancyDetails.submitted"
    />

    <template v-if="collapsed">
      <SectionHeader
        text="reportAvailable"
        :required="true"
        :dark="true"
      />
      <YesNo
        :model="store.pregnancyDetails.reportAvailable"
        v-on:action="value => store.addPregnancyDetails('reportAvailable', value)"
      />

      <SectionHeader text="pregnancyInWeeks" :required="false" :dark="true" />
      <NumberInput
        label="weeks"
        :showLabel="true"
        :model="store.pregnancyDetails.pregnancyInWeeks"
        v-on:action="value => store.addPregnancyDetails('pregnancyInWeeks', value)"
      />

      <SectionHeader text="Which bloodgroup do you have?" :required="false" :dark="true" />
      <DoubleDropdown
        :data="[['A', 'B', '0', 'AB', 'I don\'t know'], ['Rhesus +', 'Rhesus -', 'I don\'t know']]"
        :labels='["A/B/O/AB", "Rhesus + / Rhesus -"]'
        :showLabels="true"
        :firstChoice="store.pregnancyDetails.bloodGroupAbZ"
        :secondChoice="store.pregnancyDetails.bloodGroupRhesusFactor"
        v-on:firstAction="value => store.addPregnancyDetails('bloodGroupAbZ', value)"
        v-on:secondAction="value => store.addPregnancyDetails('bloodGroupRhesusFactor', value)"
      />

      <SectionHeader
        text="lastGynecologicalVisit"
        :required="false"
        :dark="true"
      />
      <Dropdown
        label="Never"
        :data="['Never', 'last year', '6 months', 'I don\'t know']"
        :choice="store.pregnancyDetails.lastGynecologicalVisit"
        v-on:action="value => store.addPregnancyDetails('lastGynecologicalVisit', value)"
      />
      
      <Button :text="edit ? 'Update' : 'Submit'" v-on:action="submit" :active="store.pregnancyDetailsComplete" />
    </template>
  </div>
</template>

<script>
import { observer } from "mobx-vue";

import SectionHeader from "../SectionHeader";
import YesNo from "../YesNo";
import DoubleDropdown from "../DoubleDropdown";
import NumberInput from "../NumberInput";
import Button from "../Button";
import Dropdown from "../Dropdown";
export default observer({
  name: "Pregnancy",
  data() {
    return {
      collapsed: true,
    }
  },
  props: {
    store: Object,
    edit: Boolean
  },
  components: {
    SectionHeader,
    YesNo,
    DoubleDropdown,
    NumberInput,
    Button,
    Dropdown
  },
  methods: {
    submit: function() {
      this.store.pregnancyDetails.submitted = true
      localStorage.setItem(
        "pregnancyDetails",
        JSON.stringify(this.store.pregnancyDetails)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.collapsed = !this.collapsed
        window.scrollTo(0,0)
      }
    }
  }
})
</script>

<style>
</style>